export default __webpack_public_path__ + "static/media/Remove.e3afc034.ico";